module.exports = __webpack_public_path__ + "static/media/btnFirst.856f9150.svg";